import { useState } from "react";
import {
  Card,
  CardContent,
  Typography,
  TextField,
  Grid,
  Button,
  Snackbar,
  Alert,
  Backdrop,
  Container,
  CircularProgress,
} from "@mui/material";
import { FaMapMarkerAlt } from "react-icons/fa";
import Box from "@mui/material/Box";
import { useLocation } from "react-router-dom";
import { vendorApi } from "../../api/api";
const MarketPriceBody = () => {
  const location = useLocation();
  const { PropertyName, City, PropertyId, UnitPrice } = location.state || {};
  const [loading, setLoading] = useState(false); // Loader state
  const [snackbarOpen, setSnackbarOpen] = useState(false); // Snackbar visibility
  const [snackbarMessage, setSnackbarMessage] = useState(""); // Snackbar message
  const [snackbarSeverity, setSnackbarSeverity] = useState("success"); // Snackbar severity
  const [unitprice, setUnitPrice] = useState(UnitPrice);
  const handleSnackbarClose = () => setSnackbarOpen(false);
  const validate = () => {
    let isValid = true;
    // Validate price
    if (!unitprice || unitprice === "") {
      isValid = false;
    }
    return isValid;
  };

  const saveProperty = async (event) => {
    event.preventDefault();
    if (!validate()) return;
    // Prepare data for the PUT request
    const data = {
      PropertyId: PropertyId,
      UnitPrice: unitprice,
    };
    setLoading(true);
    try {

      const response = await vendorApi.updatePrice(data);
      setSnackbarMessage("Price Updated successfully!");
      setSnackbarSeverity("success");
      setSnackbarOpen(true); // Show success snackbar
    } catch (error) {
      setSnackbarMessage("Failed to update price. Please try again.");
      setSnackbarSeverity("error");
      setSnackbarOpen(true); // Show error snackbar
    } finally {
      setLoading(false); // Hide loading indicator
    }
  };
  const editCancelProperty = () => {
    window.location.href = "/property/";
  };

  return (
    <Container sx={{ py: 5, maxWidth: "80%" }}>
      {/* Loader */}
      <Backdrop open={loading} sx={{ zIndex: 1300, color: "#fff" }}>
        <CircularProgress color="inherit" />
      </Backdrop>
      {/* Snackbar */}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbarSeverity}
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
      <Box sx={{ margin: "5% 8%" }}>
        <Typography
          variant="h4"
          component="h1"
          sx={{
            color: "#13216E",
            fontWeight: 600,
            fontSize: "24px",
            marginBottom: "20px",
          }}
        >
          Market Price
        </Typography>
        <Card sx={{ width: "95%", marginBottom: 3 }}>
          <CardContent>
            <Typography
              variant="h5"
              sx={{ color: "#4E0DFF", fontSize: "20px" }}
            >
              {PropertyName}
            </Typography>
            <Typography
              variant="subtitle1"
              sx={{ color: "#13216E", fontSize: "16px" }}
            >
              <FaMapMarkerAlt /> {City}
            </Typography>
            <Typography
              variant="subtitle1"
              sx={{ color: "#13216E", fontSize: "16px" }}
            >
              UnitPrice : {UnitPrice}
            </Typography>




          </CardContent>
        </Card>
        <Card sx={{ width: "95%", marginBottom: 3 }}>
          <CardContent>
            <Grid item xs={12}>
              <TextField
                label="Unit Price"
                fullWidth
                type="number"
                name="unitprice"
                value={unitprice}
                onChange={(e) => setUnitPrice(e.target.value)}

              />
            </Grid>


            <Grid container justifyContent="flex-end" spacing={2} style={{ marginTop: '10px' }}>
              <Grid item>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={saveProperty}
                >
                  Save Changes
                </Button>
              </Grid>
              <Grid item>
                <Button
                  variant="outlined"
                  color="secondary"
                  onClick={editCancelProperty}
                >
                  Cancel
                </Button>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Box>
    </Container>
  );
};
export default MarketPriceBody;